export const filterText = (s) => {
    return s.replace(/[\u0085\u00A0\u1680\u180e\u2000-\u2009\u200a\u200b\u2028\u2029\u202f\u205f\u3000]/g,'');
};